<div class="container-fluid">


    <div class="row">
        <div>
            <router-outlet></router-outlet>
        </div>
        <div id="login" class="col-md-12 col-lg-12 col-sm-12 col-xs-12">

            <div *ngIf="globalData.isUserLogged == false" id="login-row"
                class="justify-content-center align-items-center">
                <div id="login-column" class="col-md-3"
                    style=" position: absolute; left: 50%; top: 20%; transform: translate(-50%, 20%);">
                    <div class="box">
                        <div class="shape1"></div>
                        <div class="shape2"></div>
                        <div class="shape3"></div>
                        <div class="shape4"></div>
                        <div class="shape5"></div>
                        <div class="shape6"></div>
                        <div class="shape7"></div>
                        <div class="float">

                            <form novalidate (ngSubmit)="home()" [formGroup]="loginForm">
                                <div class="form-group">
                                    <label for="username" class="text-white">Username:</label><br>
                                    <input type="email" name="username" id="username" class="form-control"
                                        formControlName="email"
                                        [class.error1]="!loginForm.controls.email.valid && loginForm.controls.email.dirty">
                                </div>

                                <div no-lines
                                    *ngIf="( loginForm.get('email').hasError('minlength') || loginForm.get('email').hasError('pattern') ||loginForm.get('email').hasError('required') ) && loginForm.get('email').touched">
                                    <div style="color: red !important" class="error"
                                        *ngIf="loginForm.get('email').hasError('required') && loginForm.get('email').touched">
                                        Per favore inserire la propria e-mail
                                    </div>
                                    <div style="color: red !important" class="error"
                                        *ngIf="loginForm.get('email').hasError('pattern') && loginForm.get('email').touched">
                                        Indirizzo E-Mail non valido
                                    </div>
                                </div>


                                <div class="form-group">
                                    <label for="password" class="text-white">Password:</label><br>
                                    <input type="password" name="userData.password" id="password" class="form-control"
                                        formControlName="password"
                                        [class.error1]="!loginForm.controls.password.valid && loginForm.controls.password.dirty">
                                </div>

                                <div no-lines
                                    *ngIf="( loginForm.get('password').hasError('minlength') || loginForm.get('password').hasError('maxlength') ||loginForm.get('password').hasError('required') ) && loginForm.get('password').touched">
                                    <div style="color: red !important" class="error"
                                        *ngIf="loginForm.get('password').hasError('required') && loginForm.get('password').touched">
                                        Per favore inserire una password
                                    </div>
                                    <div style="color: red !important" class="error"
                                        *ngIf="loginForm.get('password').hasError('minlength') && loginForm.get('password').touched">
                                        Lunghezza minima 6 caratteri
                                    </div>
                                    <div style="color: red !important" class="error"
                                        *ngIf="loginForm.get('password').hasError('maxlength') && loginForm.get('password').touched">
                                        Lunghezza massima 12 caratteri
                                    </div>
                                </div>


                                <div class="form-group">
                                    <button name="submit" class="btn btn-info btn-md" value="submit"
                                        [disabled]="loginForm.invalid">Accedi</button>
                                </div>


                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>
<!--     <div id="footer"></div>
    <div style="display:none; " data-toggle="modal" data-target="#erroreLoginModal">  </div>

    <div class="modal fade" id="erroreLoginModal" tabindex="-1" role="dialog" aria-labelledby="erroreLoginModalLabel"
        aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h2 class="modal-title" id="erroreLoginModalLabel">Modifica dati amministratore</h2>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="justify-content-center align-items-center">

                    </div>
                </div>
            </div>
            <div class="modal-footer">

                <button type="button" data-dismiss="modal" class="btn btn-primary">OK</button>
            </div>
        </div>
    </div>
 -->